// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../runtime/json/scalar";
import { default as serialize, } from "../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../runtime/wire/scalar";
import { default as deserialize, } from "../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        accessToken: "",
        refreshToken: "",
        userId: "",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.accessToken !== undefined)
        result.accessToken = tsValueToJsonValueFns.string(value.accessToken);
    if (value.refreshToken !== undefined)
        result.refreshToken = tsValueToJsonValueFns.string(value.refreshToken);
    if (value.userId !== undefined)
        result.userId = tsValueToJsonValueFns.string(value.userId);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.accessToken !== undefined)
        result.accessToken = jsonValueToTsValueFns.string(value.accessToken);
    if (value.refreshToken !== undefined)
        result.refreshToken = jsonValueToTsValueFns.string(value.refreshToken);
    if (value.userId !== undefined)
        result.userId = jsonValueToTsValueFns.string(value.userId);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.accessToken !== undefined) {
        const tsValue = value.accessToken;
        result.push([1, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.refreshToken !== undefined) {
        const tsValue = value.refreshToken;
        result.push([2, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.userId !== undefined) {
        const tsValue = value.userId;
        result.push([3, tsValueToWireValueFns.string(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.accessToken = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.refreshToken = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.userId = value;
    }
    return result;
}
